import {
    $getSelection,
    $isRangeSelection,
    createCommand,
    LexicalNode,
} from "lexical";
import {useEffect} from "react";
import {useLexicalComposerContext} from "@lexical/react/LexicalComposerContext";
import {
    $createListItemNode,
    $isListNode,
    REMOVE_LIST_COMMAND,
} from "@lexical/list";
import {$createDashListNode} from "../nodes/dash-list-node";

export const INSERT_DASH_LIST_COMMAND = createCommand<void>();

export default function DashListPlugin() {
    const [editor] = useLexicalComposerContext();

    useEffect(() => {
        return editor.registerCommand(
            INSERT_DASH_LIST_COMMAND,
            () => {
                editor.update(() => {
                    const selection = $getSelection();
                    if (!$isRangeSelection(selection)) return;

                    const anchor = selection.anchor.getNode();
                    if (anchor.getType() === "root") {
                        return;
                    }
                    const topLevel = anchor.getTopLevelElementOrThrow();

                    // Toggle off jeśli już jesteśmy w dash-liście
                    if ($isListNode(topLevel) && topLevel.getType() === "dash-list") {
                        editor.dispatchCommand(REMOVE_LIST_COMMAND, undefined);
                        return true;
                    }

                    // Zamiana innej listy na dash-list
                    if ($isListNode(topLevel) && topLevel.getType() !== "dash-list") {
                        const newList = $createDashListNode();
                        topLevel.getChildren().forEach((li) => newList.append(li));
                        topLevel.replace(newList);
                        return true;
                    }

                    // Pobierz wszystkie top-level blokowe nody w zaznaczeniu
                    const nodes = selection.getNodes();
                    const blocks: any[] = [];
                    for (const node of nodes) {
                        if (node.getType() === "root") {
                            continue;
                        }
                        try {
                            const block = node.getTopLevelElementOrThrow();
                            if (!blocks.includes(block)) blocks.push(block);
                        } catch {
                            // pomijamy nody, które nie mają poprawnego top-level elementu
                        }
                    }

                    if (blocks.length === 0) return;

                    // Utwórz JEDNĄ listę i wstaw ją przed pierwszym blokiem
                    const dashList = $createDashListNode();
                    const firstBlock = blocks[0];
                    firstBlock.insertBefore(dashList);

                    // Każdy blok zamień w li i przenieś jego dzieci
                    for (const block of blocks) {
                        const li = $createListItemNode();
                        const children = block.getChildren();
                        children.forEach((c: LexicalNode) => li.append(c));
                        dashList.append(li);
                        block.remove();
                    }
                });

                return true;
            },
            0
        );
    }, [editor]);

    return null;
}
